// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import StyledOverlay from "@synd/App/Components/Common/StyledOverlay";
import XngLoadingOverlayUtilities from "@synd/App/Components/Common/XngLoadingOverlayUtilities";
import { isMobileScreen, isSmallMobileScreen, isTabletScreen, isWideScreen } from "@synd/XDL/Utilities";
import React, { FC, useEffect } from "react";

const XngUtilities: FC = () => {
    const dispatch = useAppDispatch();

    const handleResize = () => {
        const isSmallMobile = isSmallMobileScreen();
        const isMobileScreenValue = isMobileScreen();
        const isTabletScreenValue = isTabletScreen();
        const isWideScreenValue = isWideScreen();

        dispatch({
            type: "xCommon/update",
            data: {
                key: "screenFlags",
                value: {
                    isSmallMobileScreen: isSmallMobile,
                    isMobileScreen: isMobileScreenValue,
                    isTabletScreen: isTabletScreenValue,
                    isWideScreen: isWideScreenValue,
                },
            },
        });
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize, { passive: true });
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <>
            <XngLoadingOverlayUtilities />
            <StyledOverlay />
        </>
    );
};

export default XngUtilities;
